import { Component, Input } from "@angular/core";
import { DeckLayer } from "@apiserver-rest/ponder-data-client-base";
import { AuthService } from "@ponder-core/auth/auth.service";
import { formatCurrency } from "@ponder-shared/utils/numberFormatter";
import { isMobileScreen } from "@ponder-shared/utils/screenBreakpoints";

@Component({
    selector: "deck-value-stats",
    imports: [],
    templateUrl: "./deck-value-stats.component.html"
})
export class DeckValueStatsComponent {
    @Input({ required: true }) public currentLayer?: DeckLayer;

    public isAuthed: boolean = false;

    private totalLayerValue: string = "$0.00";
    private totalCollectedCount: number = 0;
    private totalCollectedValue: string = "$0.00"

    public constructor(private auth: AuthService) {

    }

    public ngOnInit(): void {
        this.isAuthed = this.auth.isAuthed();
    }

    public getCurrentLayerValue(): string {
        var totalValue = 0;
        var collectedCount = 0;
        var collectedValue = 0;

        if (this.currentLayer) {
            this.currentLayer.cards?.forEach(c => {
                let normalCollectedCount = Math.min(c.count, ((c.card.collected?.count ?? 0)));                     // If collected count is 0, returns 0. Otherwise returns number of those collected, clamped to the number in the deck.
                let specialCollectedCount = Math.min(c.specialCount, ((c.card.collected?.specialCount ?? 0)));      // For example, if we have 4 of Card A in the deck but have 7 of them collected then we count only the 4 in the deck.
    
                let normalPrice = c.card.price?.normalUSD ?? 0;
                let specialPrice = c.card.price?.specialUSD ?? 0;
    
                totalValue += (c.count * normalPrice) + (c.specialCount * specialPrice);
                collectedCount += (normalCollectedCount + specialCollectedCount);
                collectedValue += (normalCollectedCount * normalPrice) + (specialCollectedCount * specialPrice);
            });
    
            this.totalLayerValue = formatCurrency(totalValue);
            this.totalCollectedCount = collectedCount;
            this.totalCollectedValue = formatCurrency(collectedValue);
        }


        return this.totalLayerValue;
    }

    public getCurrentLayerCollectedCount(): number {
        return this.totalCollectedCount;
    }

    public getCurrentLayerCollectedValue(): string {
        return this.totalCollectedValue;
    }

    public isMobileScreen(): boolean { 
        return isMobileScreen();
    }
}